import React, { useState, useEffect } from 'react';
import { create } from 'zustand';
import {
  createUser,
  generateGroup,
  getAllGroups,
  getAllUsers,
  editUser,
  editGroup,
  deleteUser,
  removeGroup,
} from 'src/queries/admin';
import { Auth, API, graphqlOperation } from 'aws-amplify';

export const useAdmin = create((set, get) => {
  return {
    groups: [],
    groupsLoading: true,
    users: [],
    usersLoading: true,
    view: 'Groups',
    viewOptions: ['Groups', 'Users'],
    selected: {},
    modalButtonLoading: true,
    setModalButtonLoading: () => {
      return set({ modalButtonLoading: true });
    },
    setSelected: (item) => {
      return set({ selected: item });
    },
    clearSelected: () => {
      return set({ selected: {} });
    },
    setView: (newView) => {
      return set({ view: newView });
    },
    getUsers: () => {
      return getAllUsers(
        (data) => {
          return set({ usersLoading: false, users: data });
        },
        () => set({ usersLoading: false })
      );
    },
    getGroups: () => {
      return getAllGroups(
        (data) => {
          set({ groupsLoading: false, groups: data });
        },
        () => set({ groupsLoading: false })
      );
    },
    createUser: async (user) => {
      const { getUsers } = get();
      try {
        set({ usersLoading: true });
        await createUser(user);
        setTimeout(() => {
          getUsers();
        }, 300);
      } catch (e) {
        console.log(e);
        set({ usersLoading: false });
        throw e;
      }
    },
    deleteUser: async (user) => {
      const { getUsers } = get();
      try {
        set({ usersLoading: true });
        await deleteUser(user);
        setTimeout(() => {
          getUsers();
        }, 300);
      } catch (e) {
        console.log(e);
        set({ usersLoading: false });
        throw e;
      }
    },
    editUser: async (user) => {
      const { getUsers } = get();
      try {
        set({ usersLoading: true });
        await editUser(user);
        setTimeout(() => {
          getUsers();
        }, 300);
      } catch (e) {
        console.log(e);
        set({ usersLoading: false });
        throw e;
      }
    },
    editGroup: async (group) => {
      const { getGroups } = get();
      try {
        set({ groupsLoading: true });
        await editGroup(group);
        setTimeout(() => {
          getGroups();
        }, 300);
      } catch (e) {
        console.log(e);
        set({ groupsLoading: false });
        throw e;
      }
    },
    createGroup: async (inputs) => {
      const { getGroups } = get();
      try {
        set({ groupsLoading: true });
        await generateGroup(inputs);
        setTimeout(() => {
          getGroups();
        }, 300);
      } catch (e) {
        console.log(e);
        set({ groupsLoading: false });
        throw e;
      }
    },
    deleteGroup: async (id) => {
      const { getGroups, getUsers, users } = get();
      try {
        set({ groupsLoading: true });

        // Strip any reference to this group from users who'd been granted access,
        // so deleting a group doesn't leave orphaned roles behind.
        const affectedUsers = users.filter((user) =>
          user.roles?.some((role) => role.groupID === id)
        );
        await Promise.all(
          affectedUsers.map((user) => {
            const newRoles = (user.roles || [])
              .filter((role) => role.groupID !== id)
              .map(({ role, groupID }) => ({ role, groupID }));
            return editUser({ id: user.id, roles: newRoles });
          })
        );

        await removeGroup(id);
        setTimeout(() => {
          getGroups();
          if (affectedUsers.length) {
            getUsers();
          }
        }, 300);
      } catch (e) {
        console.log(e);
        set({ groupsLoading: false });
        throw e;
      }
    },
  };
});
